import template from 'text!./templates/Default.html';

var definition = {
    restrict: 'E',
    scope: {
        property: '&propertyInfo',
        hideRequired: '<'
    },
    template: template
};

var directive = [function () {
    return definition;
}];
directive.definition = definition;

export default directive;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/propertyHeaders/table/Default.js
// module id = 161
// module chunks = 0